import { AuthModalComponent } from '@/app/components/layout/auth-modal/auth-modal.component';
import { inject, Injectable, signal } from '@angular/core';
import { NzModalService } from 'ng-zorro-antd/modal';
import { catchError, of } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { FsApiService } from '../auth/fs-api.service';

@Injectable({
  providedIn: 'root',
})
export class FavoritesService {
  private modalService = inject(NzModalService);
  private authService = inject(AuthService);

  private fsApi = inject(FsApiService);

  idsCompetitionFavorites = signal<string[]>([]);
  idsTeamFavorites = signal<string[]>([]);
  idsMatchesFavorites = signal<string[]>([]);
  idsLotteryFavorites = signal<string[]>([]);

  isLoadingCompetitionFavorites = signal<boolean>(false);
  isLoadingTeamFavorites = signal<boolean>(false);
  isLoadingMatchesFavorites = signal<boolean>(false);
  // isLoadingLotteryFavorites = signal<boolean>(false);

  constructor() {}

  getUserId(): string {
    // return this.authService.userDataComputed().id || '';
    const dataAuth = localStorage.getItem('auth');

    if (dataAuth) {
      const data = JSON.parse(dataAuth);
      return data.user.id || '';
    }

    return '';
  }

  validAuthFavorites(): boolean {
    if (!this.authService.isLoggedIn) {
      this.openAuthModal();
      return false;
    }

    return true;
  }

  openAuthModal() {
    this.modalService.create({
      nzContent: AuthModalComponent,
      nzFooter: null,
    });
  }

  // competitions

  checkFavoriteCompetition(competitionId: string, isFavorite: boolean) {
    if (!isFavorite) return;
    if (this.idsCompetitionFavorites().includes(competitionId)) return;

    this.idsCompetitionFavorites.update((prev) => [...prev, competitionId]);

    this.validateCompettionFavoriteWhenAdded(competitionId);
  }

  postFavoritesCompetition(competitionId: string) {
    this.isLoadingCompetitionFavorites.set(true);

    // Add the id in global state
    this.idsCompetitionFavorites.update((prev) => [...prev, competitionId]);
    this.validateCompettionFavoriteWhenAdded(competitionId);

    this.fsApi
      .post(`/competitions/${competitionId}/favorite`, {
        competitionId,
        userId: this.getUserId(),
      })
      .pipe(
        catchError((_) => {
          this.isLoadingCompetitionFavorites.set(false);

          // Remove the id in global state
          this.idsCompetitionFavorites.update((prev) =>
            prev.filter((savedId) => savedId !== competitionId)
          );
          this.validateCompettionFavoriteWhenDelete(competitionId);

          return of(null);
        })
      )
      .subscribe(() => {
        // Add the id in global state
        this.idsCompetitionFavorites.update((prev) => [...prev, competitionId]);
        this.validateCompettionFavoriteWhenAdded(competitionId);

        this.isLoadingCompetitionFavorites.set(false);
      });

    this.isLoadingCompetitionFavorites.set(false);
  }

  deleteFavoritesCompetition(competitionId: string) {
    this.isLoadingCompetitionFavorites.set(true);

    // Remove the id in global state
    this.idsCompetitionFavorites.update((prev) =>
      prev.filter((savedId) => savedId !== competitionId)
    );
    this.validateCompettionFavoriteWhenDelete(competitionId);

    this.fsApi
      .delete(`/competitions/${competitionId}/favorite`, {
        body: {
          competitionId,
          userId: this.getUserId(),
        },
      })
      .pipe(
        catchError((_) => {
          this.isLoadingCompetitionFavorites.set(false);

          // Add the id in global state
          this.idsCompetitionFavorites.update((prev) => [
            ...prev,
            competitionId,
          ]);
          this.validateCompettionFavoriteWhenAdded(competitionId);
          return of(null);
        })
      )
      .subscribe(() => {
        // Remove the id in global state
        this.idsCompetitionFavorites.update((prev) =>
          prev.filter((savedId) => savedId !== competitionId)
        );
        this.validateCompettionFavoriteWhenDelete(competitionId);

        this.isLoadingCompetitionFavorites.set(false);
      });

    this.isLoadingCompetitionFavorites.set(false);
  }

  // match

  checkFavoriteMatch(matchId: string, isFavorite: boolean) {
    if (!isFavorite) return;
    if (this.idsMatchesFavorites().includes(matchId)) return;

    this.idsMatchesFavorites.update((prev) => [...prev, matchId]);

    this.validateMatchFavoriteWhenAdded(matchId);
  }
  postFavoritesMatch(matchId: string) {
    this.isLoadingMatchesFavorites.set(true);

    // Add the id in global state
    this.idsMatchesFavorites.update((prev) => [...prev, matchId]);
    this.validateMatchFavoriteWhenAdded(matchId);

    this.fsApi
      .post(`/matches/${matchId}/favorite`, {
        matchId,
        userId: this.getUserId(),
      })
      .pipe(
        catchError((_) => {
          this.isLoadingMatchesFavorites.set(false);

          // Remove the id in global state
          this.idsMatchesFavorites.update((prev) =>
            prev.filter((savedId) => savedId !== matchId)
          );
          this.validateMatchFavoriteWhenDelete(matchId);
          return of(null);
        })
      )
      .subscribe((resp) => {
        // Add the id in global state
        this.idsMatchesFavorites.update((prev) => [...prev, matchId]);
        this.validateMatchFavoriteWhenAdded(matchId);

        this.isLoadingMatchesFavorites.set(false);
      });
  }

  deleteFavoritesMatch(matchId: string) {
    this.isLoadingMatchesFavorites.set(true);

    // Remove the id in global state
    this.idsMatchesFavorites.update((prev) =>
      prev.filter((savedId) => savedId !== matchId)
    );
    this.validateMatchFavoriteWhenDelete(matchId);

    this.fsApi
      .delete(`/matches/${matchId}/favorite`, {
        body: {
          matchId,
          userId: this.getUserId(),
        },
      })
      .pipe(
        catchError((_) => {
          this.isLoadingMatchesFavorites.set(false);

          // Add the id in global state
          this.idsMatchesFavorites.update((prev) => [...prev, matchId]);
          this.validateMatchFavoriteWhenAdded(matchId);
          return of(null);
        })
      )
      .subscribe((resp) => {
        // Remove the id in global state
        this.idsMatchesFavorites.update((prev) =>
          prev.filter((savedId) => savedId !== matchId)
        );
        this.validateMatchFavoriteWhenDelete(matchId);

        this.isLoadingMatchesFavorites.set(false);
      });
  }

  // teams
  checkFavoriteTeam(teamId: string, isFavorite: boolean) {
    if (!isFavorite) return;
    if (this.idsTeamFavorites().includes(teamId)) return;

    this.idsTeamFavorites.update((prev) => [...prev, teamId]);

    this.validateTeamFavoriteWhenAdded(teamId);
  }

  postFavoritesTeam(teamId: string) {
    this.isLoadingTeamFavorites.set(true);

    // Add the id in global state
    this.idsTeamFavorites.update((prev) => [...prev, teamId]);
    this.validateTeamFavoriteWhenAdded(teamId);

    this.fsApi
      .post(`/teams/${teamId}/favorite`, {
        teamId,
        userId: this.getUserId(),
      })
      .pipe(
        catchError((_) => {
          this.isLoadingTeamFavorites.set(false);

          // Remove the id in global state
          this.idsTeamFavorites.update((prev) =>
            prev.filter((savedId) => savedId !== teamId)
          );
          this.validateCompettionFavoriteWhenDelete(teamId);
          return of(null);
        })
      )
      .subscribe((resp) => {
        // Add the id in global state
        this.idsTeamFavorites.update((prev) => [...prev, teamId]);
        this.validateTeamFavoriteWhenAdded(teamId);

        this.isLoadingTeamFavorites.set(false);
      });
    this.isLoadingCompetitionFavorites.set(false);
  }

  deleteFavoritesTeam(teamId: string) {
    this.isLoadingTeamFavorites.set(true);

    // Remove the id in global state
    this.idsTeamFavorites.update((prev) =>
      prev.filter((savedId) => savedId !== teamId)
    );
    this.validateCompettionFavoriteWhenDelete(teamId);

    this.fsApi
      .delete(`/teams/${teamId}/favorite`, {
        body: {
          teamId,
          userId: this.getUserId(),
        },
      })
      .pipe(
        catchError((_) => {
          this.isLoadingTeamFavorites.set(false);

          // Add the id in global state
          this.idsTeamFavorites.update((prev) => [...prev, teamId]);
          this.validateTeamFavoriteWhenAdded(teamId);
          return of(null);
        })
      )
      .subscribe((resp) => {
        // Remove the id in global state
        this.idsTeamFavorites.update((prev) =>
          prev.filter((savedId) => savedId !== teamId)
        );
        this.validateCompettionFavoriteWhenDelete(teamId);

        this.isLoadingTeamFavorites.set(false);
      });

    this.isLoadingTeamFavorites.set(false);
  }

  // Saved localstoraga

  validateCompettionFavoriteWhenDelete(id: string) {
    this.localStorageDeleteV2Favorite(id, 'idListCompetitionFavorites');
  }
  validateTeamFavoriteWhenDelete(id: string) {
    this.localStorageDeleteV2Favorite(id, 'idListTeamFavorites');
  }
  validateMatchFavoriteWhenDelete(id: string) {
    this.localStorageDeleteV2Favorite(id, 'idListMatchFavorites');
  }
  validateCompettionFavoriteWhenAdded(id: string) {
    this.localStorageAddV2Favorite(id, 'idListCompetitionFavorites');
  }
  validateTeamFavoriteWhenAdded(id: string) {
    this.localStorageAddV2Favorite(id, 'idListTeamFavorites');
  }
  validateMatchFavoriteWhenAdded(id: string) {
    this.localStorageAddV2Favorite(id, 'idListMatchFavorites');
  }

  localStorageDeleteV2Favorite(id: string, keyLocal: string) {
    const localData: string | null = localStorage.getItem(keyLocal);
    if (!localData) return;

    const listFavoritesNew: string[] = JSON.parse(localData);

    const newData = listFavoritesNew.filter((item) => item !== id);
    if (newData) {
      localStorage.setItem(keyLocal, JSON.stringify(newData));
    }
  }

  localStorageAddV2Favorite(id: string, keyLocal: string) {
    const localData: string | null = localStorage.getItem(keyLocal);

    const listFavoritesNew: string[] =
      localData !== null ? JSON.parse(localData) : [];
    if (listFavoritesNew.length === 0) {
      // this.newsCompetitionFavoriteService.idsCompetitionFavorites.update(
      //   (prev) => [...prev, id]
      // );
      localStorage.setItem(keyLocal, JSON.stringify([id]));
      // console.log('no hay pero agrego');
      return;
    }

    if (listFavoritesNew.includes(id)) return;
    // this.newsCompetitionFavoriteService.idsCompetitionFavorites.update(
    //   (prev) => [...prev, id]
    // );
    listFavoritesNew.push(id);
    localStorage.setItem(keyLocal, JSON.stringify(listFavoritesNew));
    // const newData = listFavoritesNew.filter((item) => item !== id);
    // if (newData) {
    //   localStorage.setItem(keyLocal, JSON.stringify(newData));
    // }
  }
}
